/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */

/**
 * read system dependend information
 */
export class System {
  /**
   * returns true if the system is a little endian system
   */
  static isLE() {
    return this._le;
  }
  /**
   * returns true if the system is a big endian system
   */


  static isBE() {
    return !this._le;
  }

}
System._le = new Uint8Array(new Uint32Array([0x12345678]).buffer)[0] === 0x78;
//# sourceMappingURL=System.js.map